import styled from "styled-components";

interface SupportProps {
  hasAccess: boolean;
}

export const ContentSupportWpp = styled.div<SupportProps>`
  width: 200px;
  top: 12px;
  border-width: 1px;
  flex-direction: column;
  color: var(--velotax-font-color-ghost);
  cursor: pointer;
`;

export const ContentCommercial = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
  cursor: pointer;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  color: var(--velotax-font-color-ghost);
  border-top: 1px solid var(--velotax-light-gray);
  margin-bottom: 2px;
  padding: 2px 0;
  flex-shrink: 0;
  max-height: 30vh;
  overflow-y: auto;
  overflow-x: hidden;

  .plan-sidebar {
    font-size: 16px;
    user-select: none;
    color: var(--velotax-font-color-ghost);
    &.pointer {
      cursor: pointer;
    }
    strong {
      font-weight: 900;
    }
  }
`;

export const ContentNotHasAccess = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 8px;
`;

export const TextContainer = styled.div<SupportProps>`
  width: 160;
  height: 52;
  display: flex;
  flex-direction: column;
  top: 30px;
  left: 16px;
  padding: ${(props) => (props.hasAccess ? "8px 8px" : "0px 0px")};
  color: var(--velotax-font-color-ghost);
  gap: 4px;
`;

export const Title = styled.span<SupportProps>`
  width: 165px;
  height: 16px;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--ant-primary-color) !important;
`;

export const InfoText = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--white);
`;

export const InfoText2 = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--white);
`;

export const ScheduleText = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
  vertical-align: middle;
 color: var(--white);
`;

export const Button = styled.button`
  width: 170px;
  height: 40;
  top: 112px;
  left: 20px;
  border-bottom-width: 2px;
  padding: 12px;
  gap: 10px;
  background-color: var(--ant-primary-color) !important;
  color: var(--white);
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
`;

export const WarningContainer = styled.div`
  width: 100%;
  padding: 6px 8px;
  margin-bottom: 4px;
  background-color: var(--ant-warning-1);
  border-left: 2px solid var(--ant-warning-color);
  border-radius: 3px;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.9;
  }
`;

export const CollapseButton = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  background: transparent;
  border: none;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  pointer-events: none;
  color: var(--ant-warning-color) !important;
  
  .anticon {
    font-size: 12px;
    color: var(--ant-warning-color) !important;
  }
  
  svg {
    fill: var(--ant-warning-color) !important;
    color: var(--ant-warning-color) !important;
  }
`;

export const WarningTitle = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  color: var(--ant-warning-color);
  margin-bottom: 2px;
`;

export const WarningText = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: var(--ant-warning-color);
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const ScheduleContainer = styled.div`
  width: 100%;
  padding: 0 8px;
  margin-bottom: 3px;
  flex-shrink: 0;
`;

export const ScheduleTitle = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  color: var(--velotax-font-color-ghost);
  margin-bottom: 1px;
`;

export const ScheduleTextContent = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: var(--velotax-font-color-ghost);
`;

export const PhoneContainer = styled.div`
  width: 100%;
  padding: 0 8px;
  margin-bottom: 3px;
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex-shrink: 0;
`;

export const PhoneText = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: var(--velotax-font-color-ghost);
  
  strong {
    font-weight: 700;
  }
`;